module.exports = __webpack_public_path__ + "static/a-clash-of-kings-a-song-of-ice-and-fire-book-2-87e189ed0d9c6a231df6960e31175276.jpg";